export default __webpack_public_path__ + "static/media/PilarczykFormula.58058d03.png";